// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__37iNu","log":"ModalInventoryLogs_log__1gzbE","date":"ModalInventoryLogs_date__1N_V0","userName":"ModalInventoryLogs_userName__2Ij0X"};